// @flow
export { default } from './Label';
